import { inject, InjectionToken } from '@angular/core';
import { DeviceCounterReplicationService } from '../device-counter-replication.service';
import { DeviceCounterStore } from './device-counter.models';

/**
 * The device counter store — Firestore, the source of truth.
 *
 * The token stays so the store is chosen in one place and consumers depend on
 * the {@link DeviceCounterStore} contract rather than on an implementation.
 */
export const DEVICE_COUNTER_STORE = new InjectionToken<DeviceCounterStore>('DEVICE_COUNTER_STORE', {
  providedIn: 'root',
  factory: () => inject(DeviceCounterReplicationService)
});
